import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
      modals: {
        youtube: false
      },
      ambasadors: [
        {
          id: 1,
          name: 'Petr Koukal',
          job: 'badmintonista',
          img: 'a-petrkoukal.png',
          retina: 'a-petrkoukal@2x.png',
          bio: '“ZDRAVÍ A PŘEDEVŠÍM JEHO PREVENCE JE TO NEJDŮLEŽITĚJŠÍ, NA CO BYCHOM SE MĚLI V ŽIVOTĚ ZAMĚŘIT.”',
          fbLink: '',
          instagramLink: 'https://www.instagram.com/stkprochlapy/',
          ownUrl: 'https://www.stkprochlapy.cz/'
        },
        {
          id: 2,
          name: 'Jája Vaňková',
          job: 'Tanečnice',
          img: 'a-jajavankova.png',
          retina: 'a-jajavankova@2x.png',
          bio: '“Zdraví vnímám komplexně, začíná to jednotlivcem a končí zdravím naší planety.”',
          fbLink: 'https://www.facebook.com/dzajna.vankova.1',
          instagramLink: 'https://www.instagram.com/jajavankova/',
          ownUrl: 'http://jajavankova.com'
        },
        {
          id: 3,
          name: 'Markéta Lukášková',
          job: 'Spisovatelka',
          img: 'a-marketalukaskova.png',
          retina: 'a-marketalukaskova@2x.png',
          bio: '“Odjakživa naháním kamarády a blízké na kontroly k doktorovi, teď to konečně můžu dělat oficiálně.”',
          fbLink: 'https://www.facebook.com/pandi.kralovna',
          instagramLink: 'https://www.instagram.com/pandikralovna/'
        },
        {
          id: 4,
          name: 'Sandra Kisić',
          job: 'Blogerka',
          img: 'a-sandrakisic.png',
          retina: 'a-sandrakisic@2x.png',
          bio: '“Na zdraví, stejně jako na rodinu a přátele, je třeba myslet dokud je máme.”',
          fbLink: 'https://www.facebook.com/TheSandraKisic/',
          instagramLink: 'https://www.instagram.com/sandrakisic/',
          ownUrl: 'http://www.sandrakisic.com/'
        },
        {
          id: 5,
          name: 'Adam Vopička',
          job: 'Režisér',
          img: 'a-adamvopicka.png',
          retina: 'a-adamvopicka@2x.png',
          bio: '“Žijeme v konzumní době a jsme zvyklí, že všechno se dá koupit. Vyděláváme a utrácíme. Ale zdraví má úplně jiný pravidla!”',
          fbLink: '',
          instagramLink: 'https://www.instagram.com/adampiaf/',
          ownUrl: 'http://www.adamvopicka.com/'
        },
        {
          id: 6,
          name: 'Angeé Svobodová',
          job: 'Choreografka',
          img: 'a-angee.png',
          retina: 'a-angee@2x.png',
          bio: '“Zdraví je pro mě svoboda a to svobodu dělat to, co chci a úplně naplno jak chci.”',
          fbLink: 'https://www.facebook.com/angeesvoboda/',
          instagramLink: 'https://www.instagram.com/angeesvoboda/'
        },
        {
          id: 7,
          name: 'Tomáš Kavka',
          job: 'fyzioterapeut',
          img: 'a-kavka.png',
          retina: 'a-kavka@2x.png',
          bio: '“Zdraví je pro mě schopnost flexibilně reagovat na okolnosti tak, aby bylo podpořeno směřování ke smysluplným cílům.”',
          fbLink: 'http://facebook.com/UvnitrPohybu',
          instagramLink: ''
        },
        {
          id: 8,
          name: 'Barbora Hájková',
          job: 'cancer fighter',
          img: 'a-hajkova.png',
          retina: 'a-hajkova@2x.png',
          bio: '“Zdraví pro mne neznamená samozřejmost, o své zdraví musíme pečovat a být obezřetní. Projekt Sifty mnohým z nás může ukázat cestu, jak za své zdraví bojovat a to se vždy vyplatí, opravdu vždy. Šanci na život máme jen jednu!”',
          fbLink: '',
          instagramLink: 'https://www.instagram.com/baruhajkova/'
        }
      ],
      challengers: {
          'sarka-rakosnikova': {
                id: 1,
                name: 'Šárka Rákosníková',
                component: 'SarkaRakosnikova',
                alias: 'sarka-rakosnikova',
                job: 'instruktorka jógy pro děti',
                img: 'karta-sarka.png',
                retina: 'karta-sarka@2x.png',
                week: 11,
                bio: 'Šárka se věnuje józe pro děti. I na své dceři totiž vidí, jak přínosné je správné dýchání a vnímání přítomného okamžiku.',
                bioLong: 'Šárka se józe věnuje již kolem 5 let. O jógu s dětmi se začala zajímat zhruba před dvěma lety, kvůli vlastní dceři a jejímu svalovému onemocnění. Prošla speciálním ročním studiem, které jí postupně změnilo pohled na život. Jejím přáním je tuto zkušenost a inspiraci předávat dál.<br/>' +
                'Jak sama říká: “Představte si, kdybychom naučili naše děti správnému dechu a ukázali cestu, jak žít přítomným okamžikem. Nezměnilo by to pohled na svět?”<br/>' +
                '<br/>' +
                '<br/>' +
                'Jak Jóga se Sar funguje a jaké jsou její výhody: <br/>' +
                '<br/>' +
                '<ul><li>Jóga hrou</li>' +
                '<li>Kreativní jóga se Sar, plná barev, zvířátek a hudby.</li>' +
                '<li>(děti 3-6 let)</li>' +
                '<li>45 min.</li>' +
                '<li>Jóga přináší dětem- radost, pohyb, sebevědomí.</li>' +
                '<li>Ty živější děti zklidňuje, málo aktivní povzbuzuje.</li>' +
                '<li>Pomáhá správnému vývoji organismu a usnadňuje všestranný psychický a duševní rozvoj dítěte.</li>' +
                '<li>Rozvíjí dětskou fantazii, naučí děti odpočívat a čelit stresovým situacím.</li>' +
                '<li>Pomáhá lépe vnímat své tělo a respektovat sebe i své okolí v nesoutěživém prostředí.</li>' +
                '<li>Emoční stabilitu a soustředění.</li>' +
                '<li>Správné držení těla.</li>' +
                '<li>Pomáhá naučit děti správně využívat dech.</li></ul>',
                images: [
                  {
                      id: 1,
                      img: 'bio-sarka-1.png',
                      retina: 'bio-sarka-1@2x.png'
                  },
                  {
                    id: 2,
                    img: 'bio-sarka-2.png',
                    retina: 'bio-sarka-2@2x.png'
                  },
                  {
                    id: 3,
                    img: 'bio-sarka-3.png',
                    retina: 'bio-sarka-3@2x.png'
                  }
                ],
                fbLink: 'https://www.facebook.com/sar.sierra/',
                instagramLink: 'https://www.instagram.com/sar_sierra/'
          },
        'irena-markovich': {
          id: 2,
          name: 'Irena Markovich',
          alias: 'irena-markovich',
          job: 'Nutriční poradkyně',
          img: 'karta-irena.png',
          retina: 'karta-irena@2x.png',
          week: 14,
          bio: 'Je výživovou poradkyní, food stylistkou a fotografkou. Svou prací demonstruje zkušenosti nasbírané během 15-ti let života...',
          bioLong: 'Je výživovou poradkyní, food stylistkou a fotografkou. Svou prací demonstruje zkušenosti nasbírané během 15-ti let života a cestování v zahraničí, kde se zrodila její vášeň pro neobvyklé ingredience a čistý respekt k jídlu jako takovému. Je především inspirována mediteránskou a mexickou kuchyní s důrazem na čerstvé suroviny a podomácku připravená jídla. V Česku vychází její recepty v časopisech Cosmopolitan a v Harper\'s Bazaar.',
          images: [
            {
              id: 1,
              img: 'bio-irena-1.png',
              retina: 'bio-irena-1@2x.png'
            },
            {
              id: 2,
              img: 'bio-irena-2.png',
              retina: 'bio-irena-2@2x.png'
            },
            {
              id: 3,
              img: 'bio-irena-3.png',
              retina: 'bio-irena-3@2x.png'
            }
          ],
          fbLink: 'facebook.com/bohemianfoodie',
          instagramLink: 'instagram.com/bohemianfoodie',
          ownUrl: 'http://bohemianfoodie.cz'
        },
        'sara-ticha-a-tomas-strnad': {
          id: 3,
          name: 'Sara Tichá a Tomáš Strnad',
          alias: 'sara-ticha-a-tomas-strnad',
          job: 'instruktoři jógy',
          img: 'karta-tomas-sara.png',
          retina: 'karta-tomas-sara@2x.png',
          week: 19,
          bio: 'Sara a Tomáš jsou instruktoři jógy, kteří si pro vás připravili drobnou výzvu na každý den v jejich 19 týdnu.',
          bioLongSara: '<span class="d-block text-xs-center mb-3 book menu-text">Sara a Tomáš si pro nás připravili jógovou výzvu, kde nás čaká na každý den jiná jógová pozice.<br/>Konkrétní pozice najdete na našem Facebooku.<br />Namaste.</span><strong>Sara</strong> se věnuje józe od roku 2011. Její styl učení je hravý a inovativní, jejím cílem je vzbudit zájem a motivovat studenty k dalšímu sebevzdělávání. Přestože se Sara narodila a vyrostla na Slovensku, svá dospívající léta strávila cestováním,<br/>' +
            'poznáváním odlišných kultur a tradic. Po dokončení střední školy se odstěhovala do Vídně, kde také dnes žije a působí jako učitelka jógy.<br/>' +
            'Pohyb jako takový byl součástí Sary života už od dětství, hrála tenis, věnovala se také tanci.<br/>' +
            'V průběhu dospívajících let se naučila, že nejlepším způsobem,jak umlčet mysl, je zapřáhnout tělo.<br/>' +
            'Sara začala praktikovat jógu v roce 2011 spolu se svoji maminkou a bratrem v jednom z jógových studií v Bratislavě. Ikdyž to nebyla láska na první pohled, pokaždé si k józe našla cestu zpátky. Díky ní potom začala nahlížet na svět jinak. V roce 2016 si Sara udělala certifikát učitele a v tomto momentě se stala jóga její profesí.<br/>' +
            'Sara věří, že praktikování není omezeno časovým limitem jógové lekce, velmi důležité je totiž také vnímání naší mysli a našeho fyzického těla mimo jógovou podložku. Sary styl učení je hravý a inovativní, jejím cílem je vzbudit zájem a motivovat své studenty k dalšímu sebevzdělávání v rámci světu jógy.<br/>',
          bioLongTomas: '<strong>Tomáše</strong> si jóga našla před 3 lety na Novém Zélandu. Od dob kdy začal s jógovou praxí se jeho vnímání života změnilo od základu, začal více vnímat sebe samého a pomohla mu k několika zásadním rozhodnutím. Například podstoupit učitelský kurz v Indii, kde jeho cesta jógou získala naprosto jiný směr, po návratu z Indie na Nový Zéland do města Christchurchm kde začal s výukovou v místním studiu. Výuka Power vinyasy, Jin a Jin Jang jógy se stala jeho srdeční záležitostí.<br/>' +
            'Jeho život je plný energie, kterou se snaží šířit na každém kroku, lekce má v současné době v Energy studiu, kde se těší na vzájemnou výměnu energií a sdílení životních příběhů.<br/>',
          images: [
            {
              id: 1,
              img: 'bio_tomas-sara-1.png',
              retina: 'bio_tomas-sara-1@2x.png'
            }
          ],
          fbLinkSara: 'https://www.facebook.com/saratichayoga/',
          instagramLinkSara: 'https://www.instagram.com/sarahticha/',
          ownUrlSara: 'http://saraticha.com',
          fbLinkTomas: 'https://www.facebook.com/Tomash.Strnad/',
          instagramLinkTomas: 'https://www.instagram.com/tomash_strnad/',
          ownUrlTomas: 'https://www.tomashstrnad.com/'
        },
        'eliska-boleckova': {
          id: 4,
          name: 'Eliška Bolečková',
          alias: 'eliska-boleckova',
          job: 'tanečnice',
          img: 'karta-eliska.png',
          retina: 'karta-eliska@2x.png',
          week: 27,
          bio: 'Tančí, kreslí, píše. Právě tanci se věnuje od svých 8 let a od roku 2012 je členem taneční a kreativní skupiny Projekt AWA.',
          bioLong: 'Tančí, kreslí, píše. Právě tanci se věnuje od svých 8 let a od roku 2012 je členem taneční a kreativní skupiny Projekt AWA (Art With Attitude), se kterou prošla tanečními soutěžemi, ale dále se skupinou rozvíjejí i produkční činnost a to díky založení akce Urban Culture Games, která každoročně propojuje městské subkultury v 1 čas na 1 místě.<br/>' +
            'Vidět ji můžete ve videoklipech interpretů českých i zahraničních. Např.: Aurora - Queendom, Thom Artway - High Above The Trees, Victoria Velvet - You lie nebo<br/>' +
            'Vesna - Kytička a další. V současné době doprovází norskou zpěvačku Auroru s dalšími českými tanečníky na jejích koncertech, spolupracuje s kreativní skupinou diVize a zahlédnout jste ji mohli v TV shows Česko Slovenská Superstar, Tvoje tvář má známý hlas nebo již druhým rokem v zahajovací ceremonii Karlovarského Filmového Festivalu v režii bratří Cabanů.<br/>',
          images: [
            {
              id: 1,
              img: 'bio-eliska-1.png',
              retina: 'bio-eliska-1@2x.png'
            },
            {
              id: 2,
              img: 'bio-eliska-2.png',
              retina: 'bio-eliska-2@2x.png'
            },
            {
              id: 3,
              img: 'bio-eliska-3.png',
              retina: 'bio-eliska-3@2x.png'
            }
          ],
          fbLink: 'https://www.facebook.com/EFox.Bolek',
          instagramLink: 'https://instagram.com/eliskaboleckova'
        },
        'tomas-bezucha': {
          id: 5,
          name: 'Tomáš Bezucha',
          alias: 'tomas-bezucha',
          job: 'instruktor krav maga',
          img: 'karta-tomas.png',
          retina: 'karta-tomas@2x.png',
          week: 35,
          bio: 'Tomáš Bezucha je hlavním instruktorem pro Krav Maga Zone CZ v Praze. Bojovým uměním/sportům se věnuje od dětství.',
          bioLong: 'Tomáš Bezucha je hlavním instruktorem pro Krav Maga Zone CZ v Praze.<br/>' +
            'Tomáš se věnoval různým druhům sportu již od raného dětství. Nejvíce se zabýval sporty týmovými (hokej, hokejbal, fotbal), kde se pohyboval v několika kolektivech a naučil se týmové práce.<br/>' +
            'Bojovým uměním/sportům se věnuje od dětství. Ve dvanácti letech začal s Aikidem. Postupem času přešel ke Kickboxu, Musadu, Thajskému boxu, Boxu, MMA a Brazilian Jiu Jitsu.<br/>' +
            'Krav Maze se intenzivně věnuje od roku 2009. Instruktorský kurz pro civilisty absolvoval v roce 2011 a to pod vedením Amnona Darsy, Tamira Gilada a Haima Sassona. Instruktorský kurz pro ozbrojené složky úspěšně absolvoval dva roky poté opět pod vedením Amnona Darsy. Před vstupem do Krav Maga Zone působil v mezinárodní federaci, kde získal ocenění jako TOP instruktor.<br/>' +
            'Jako instruktor sebeobranného systému se snaží být co nejkomplexnější ve svém oboru. Neustále se vzdělává od těch nejlepších ve svých oborech. Každým rokem se zúčastňuje instruktorských updatů v Izraeli a v Evropě.<br/>' +
            'Spolu s Krav Magou se zároveň věnuje thajskému boxu a boxu klasickému. Dále se také soustřeďuje na boj na zemi a to konkrétně brazilskému jiu jitsu a volnému stylu. Dvakrát za rok odjíždí do Thajska a to konkrétně do světoznámého profesionálního gymu Phuket TOP Team. V tomto gymu trénuje dvou fázovým režimem denně. Na trénincích se potkává s profesionálními bojovníky z UFC, kteří se zde připravují na svoje zápasy.<br/>' +
            'Kondičně a silově se připravuje v KB5-STRONGFIRST.<br/>' +
            'Působí jako trenérský partner pro Hayashi – ­veškeré vybavení pro bojové sporty.<br/>' +
            'Má dlouholeté zkušenosti v bezpečnostním oboru. Ochrana osob a majetku, osobní ochrana.<br/>',
          images: [
            {
              id: 1,
              img: 'bio-tomas-1.png',
              retina: 'bio-tomas-1@2x.png'
            },
            {
              id: 2,
              img: 'bio-tomas-2.png',
              retina: 'bio-tomas-2@2x.png'
            }
          ],
          fbLink: 'https://www.facebook.com/tomasbezucha',
          instagramLink: 'https://www.instagram.com/tomasbez/',
          ownUrl: 'http://www.kravmaga-praha.cz/'
        },
        'marie-salomonova': {
          id: 6,
          name: 'Marie Salomonová',
          alias: 'marie-salomonova',
          job: 'neurovědkyně',
          img: 'karta-maruska.png',
          retina: 'karta-maruska@2x.png',
          week: 41,
          bio: 'Maruška vystudovala neurovědy na University of Nottingham. Spolu s Terezou Růžičkovou rozjela kampaň Nevypusť duši.',
          bioLong: 'Maruška vystudovala neurovědy na britské University of Nottingham, kde byla aktivní členkou Student Minds a v rámci univerzity se zapojila i do kampaně Time to Change. Po návratu do Čech se spolu s Terezou Růžičkovou rozhodla rozjet kampaň Nevypusť duši a později se postarala o přerod tohoto studentského projektu do neziskové organizace. Připravovala sérii pilotních workshopů „Duševní zdravověda pro teenagery“ a péči o duševní zdraví se snaží dostat i do skautských oddílů a vůbec kamkoli, kde je jí třeba – tedy všude. V ND koordinuje projekty, komunikuje s partnery, vytváří programy workshopů a spoustu dalšího. Zajímá se o inovativní pedagogiku, přírodní vědy a výzkum v medicíně. Baví ji pečení a zdobení cupcakes, výroba čokoládových pralinek, kvalitní seriály a zpěv. ',
          images: [
            {
              id: 1,
              img: 'bio-maruska-1.png',
              retina: 'bio-maruska-1@2x.png'
            },
            {
              id: 2,
              img: 'bio-maruska-2.png',
              retina: 'bio-maruska-2@2x.png'
            },
            {
              id: 3,
              img: 'bio-maruska-3.png',
              retina: 'bio-maruska-3@2x.png'
            }
          ],
          fbLink: 'https://www.facebook.com/nevypustdusi/',
          instagramLink: 'https://www.instagram.com/maya.salo/',
          ownUrl: 'http://nevypustdusi.cz/'
        },
        'pepe-kalensky': {
          id: 7,
          name: 'Pepé Kalenský',
          alias: 'pepe-kalensky',
          job: 'freeskier a trenér freeski',
          img: 'karta-pepe.png',
          retina: 'karta-pepe@2x.png',
          week: 47,
          bio: 'Pepé je mistr ČR ve slopestylu a reprezentant v akrobatickém lyžování. Je také jednou z nejdůležitějších osobností ve freeski v ČR.',
          bioLong: 'Pepé je mistr ČR ve slopestylu a reprezentant v akrobatickém lyžování. Je také jednou z nejdůležitějších osobností v oblasti freeski a jeho rozvoje v České Republice. Této disciplíně se věnuje od svých 14 let, kdy popularita tohoto sportu byla mizivá. XX se stal úspěšným průkopníkem, je zakladatelem Akademie freestyle lyžování, jejímž cílem je zaujmout potenciální budoucí reprezentanty. XX pořádá mimojiné i freeski kempy pro veřejnost, kterých se můžou zúčastnit všechny věkové kategorie. Podílel se jako producent na několika freeski filmech, jako je například Separation movie, či eXcelent Separation. Momentálně je také předsedou disciplíny Big Air, tedy akrobacie ve vzduchu.',
          images: [
            {
              id: 1,
              img: 'bio-pepe-1.png',
              retina: 'bio-pepe-1@2x.png'
            },
            {
              id: 2,
              img: 'bio-pepe-2.png',
              retina: 'bio-pepe-2@2x.png'
            },
            {
              id: 3,
              img: 'bio-pepe-3.png',
              retina: 'bio-pepe-3@2x.png'
            }
          ],
          fbLink: 'https://www.facebook.com/pepe.kalensky',
          instagramLink: 'https://www.instagram.com/pepekalensky/',
          ownUrl: 'https://www.facebook.com/freestyleakademie/?eid=ARCoXXUkCZNttd4GnuJX7cj0CZRLUNuM35fH2S612pxqXisboFX_hNG5_7i3IkBvXcQCu0V4lGNlheNS&timeline_context_item_type=intro_card_work&timeline_context_item_source=1405782538&fref=tag'
        }
      },
      availableChallengers: [
        'sarka-rakosnikova',
        'irena-markovich',
        'sara-ticha-a-tomas-strnad',
        'eliska-boleckova',
        'tomas-bezucha',
        'marie-salomonova',
        'pepe-kalensky'
      ],
      challengersSelect: [
        'Šárka Rákosníková - jóga pro děti',
        'Irena Markovich - nutriční poradkyně',
        'Sara Tichá a Tomáš Strnad - jóga',
        'Eliška Bolečková - tanec',
        'Tomáš Bezucha - krav maga',
        'Marie Salomonová - duševní zdraví',
        'Pepe Kalenský - freeski'
      ],
      weekChallenges: [
        {
          id: 1,
          type: 'vyziva',
          text: 'Začneme zlehka: pij pouze neperlivou vodu (můžeš přidat čerstvé ovoce a zeleninu)',
          challenger: ''
        },
        {
          id: 2,
          type: 'pohyb',
          text: 'Udělej tento týden 52 dřepů',
          challenger: ''
        },
        {
          id: 3,
          type: 'vzdelani',
          text: 'Jdi na web www.sifty.eu a přečti si 1 libovolný článek a 1 libovolnou infografiku',
          challenger: ''
        },
        {
          id: 4,
          type: 'prevence',
          text: 'Zajdi si do sauny',
          challenger: ''
        },
        {
          id: 5,
          type: 'psychohygiena',
          text: 'Zima svádí k jednomu - přečti si knížku dle vlastního výběru',
          challenger: ''
        },
        {
          id: 6,
          type: 'vyziva',
          text: 'Nepij alkohol',
          challenger: ''
        },
        {
          id: 7,
          type: 'prevence',
          text: 'Objednej se na preventivní kontrolu k obvodnímu lékaři (krev, tlak, moč) a následně tam zajdi',
          challenger: ''
        },
        {
          id: 8,
          type: 'psychohygiena',
          text: 'Nedívej se celý týden na televizi (ani na jiných přístrojích, žádné seriály, filmy, ani nic podobného)',
          challenger: ''
        },
        {
          id: 9,
          type: 'pohyb',
          text: 'Nejezdi výtahem',
          challenger: ''
        },
        {
          id: 10,
          type: 'vyziva',
          text: 'Jez 5x denně menší porce. Snídaně, svačina, oběd, svačina a večeře',
          challenger: ''
        },
        {
          id: 11,
          type: 'pohyb',
          text: 'Výzva Šárky Rákosníkové',
          challenger: 'sarka-rakosnikova'
        },
        {
          id: 12,
          type: 'prevence',
          text: 'Spi 8 hodin denně',
          challenger: ''
        },
        {
          id: 13,
          type: 'vzdelani',
          text: 'Na webu Sifty si pozorně přečti infografiku na téma nejčastějších příčin smrti v EU bit.ly/Sifty13',
          challenger: ''
        },
        {
          id: 14,
          type: 'vyziva',
          text: 'Výzva Bohemian Foodie - Ireny Markovich',
          challenger: 'irena-markovich'
        },
        {
          id: 15,
          type: 'pohyb',
          text: 'Ujdi alespoň 10 000 kroků denně',
          challenger: ''
        },
        {
          id: 16,
          type: 'prevence',
          text: 'Nekuř',
          challenger: ''
        },
        {
          id: 17,
          type: 'vyziva',
          text: 'Jez každý den alespoň jednu živinu bohatou na jód, nebo si pořiď himalájskou sůl bohatou na jód',
          challenger: ''
        },
        {
          id: 18,
          type: 'psychohygiena',
          text: 'Každý den obejmi někoho, na kom ti záleží',
          challenger: ''
        },
        {
          id: 19,
          type: 'pohyb',
          text: 'Výzva Sarah Tiché & Tomáše Strnada',
          challenger: 'sara-ticha-a-tomas-strnad'
        },
        {
          id: 20,
          type: 'psychohygiena',
          text: 'Udělej si výlet do přirody a vezmi s sebou někoho, na kom ti záleží',
          challenger: ''
        },
        {
          id: 21,
          type: 'vyziva',
          text: 'Jezte tento týden pouze sezónní a lokální ovoce a zeleninu',
          challenger: ''
        },
        {
          id: 22,
          type: 'prevence',
          text: 'Objednej se a následně zajdi na kontrolu mateřských znamének',
          challenger: ''
        },
        {
          id: 23,
          type: 'pohyb',
          text: 'Celý týden choď pěšky alespoň jednu cestu do práce, do školy, na nákup nebo třeba se psem',
          challenger: ''
        },
        {
          id: 24,
          type: 'prevence',
          text: 'Daruj krev',
          challenger: ''
        },
        {
          id: 25,
          type: 'vyziva',
          text: 'Každý den sněz alespoň 2 kusy zeleniny a 2 kusy ovoce',
          challenger: ''
        },
        {
          id: 26,
          type: 'psychohygiena',
          text: 'Vynech sociální média (pokud se tím živíš, použij pouze business manager)',
          challenger: ''
        },
        {
          id: 27,
          type: 'pohyb',
          text: 'Výzva Elišky Bolečkové',
          challenger: 'eliska-boleckova'
        },
        {
          id: 28,
          type: 'prevence',
          text: 'Projdi si rodinnou anamnézu, ať víš, k čemu máš větší předpoklad (geny jsou geny)',
          challenger: ''
        },
        {
          id: 29,
          type: 'vyziva',
          text: 'Nech svůj organizmus odpočinout. Vyzkoušej jednodenní půst - pij pouze vodu, případně jez jen ovoce a zeleninu.',
          challenger: ''
        },
        {
          id: 30,
          type: 'vzdelani',
          text: 'Pečlivě si prohlédni celé své tělo a začni to dělat pravidelně. Přemýšlíš proč? Podívej se na bit.ly/Sifty30',
          challenger: ''
        },
        {
          id: 31,
          type: 'pohyb',
          text: 'Jdi si zaplavat a volným stylem uplav tolik bazénů, na kolik se cítíš',
          challenger: ''
        },
        {
          id: 32,
          type: 'psychohygiena',
          text: 'Každý večer v 18:00 vypni veškerou elektroniku (telefon, televize, počítač, tablet,..)',
          challenger: ''
        },
        {
          id: 33,
          type: 'vyziva',
          text: 'Dej si ke každému slanému jídlu zeleninovou přílohu dle vlastního výběru',
          challenger: ''
        },
        {
          id: 34,
          type: 'prevence',
          text: 'Zkontroluj si očkovací průkaz',
          challenger: ''
        },
        {
          id: 35,
          type: 'pohyb',
          text: 'Výzva Tomáše Bezuchy',
          challenger: 'tomas-bezucha'
        },
        {
          id: 36,
          type: 'vzdelani',
          text: 'Na webu Sifty si pozorně přečti rozhovor na téma duševního zdraví bit.ly/Sifty36',
          challenger: ''
        },
        {
          id: 37,
          type: 'psychohygiena',
          text: 'Najdi si čas na své blízké a popovídejte si o tom, jak se máte, cítíte a co vás a je trápí ',
          challenger: ''
        },
        {
          id: 38,
          type: 'vyziva',
          text: 'Dej si každý den alespoň jednu potravinu bohatou na vitamín C',
          challenger: ''
        },
        {
          id: 39,
          type: 'prevence',
          text: 'Objednej sebe, nebo staršího příbuzného/příbuznou na EKG',
          challenger: ''
        },
        {
          id: 40,
          type: 'pohyb',
          text: 'Naběhej tento týden alespoň 5 km',
          challenger: ''
        },
        {
          id: 41,
          type: 'psychohygiena',
          text: 'Výzva Máji Salomonové',
          challenger: 'vyzva-maji-salomonove'
        },
        {
          id: 42,
          type: 'vyziva',
          text: 'Vynech fast foody',
          challenger: ''
        },
        {
          id: 43,
          type: 'pohyb',
          text: 'Zkus tento týden vydžet dohromady alespoň 5 minut v tzv. planku',
          challenger: ''
        },
        {
          id: 44,
          type: 'vzdelani',
          text: 'Na webu Sifty si udělej libovolný kvíz bit.ly/Sifty44',
          challenger: ''
        },
        {
          id: 45,
          type: 'prevence',
          text: 'Znáš STK pro chlapy? Podívej se na jejich web a pokud jsi muž, objednej se a následně jdi na kontrolu. Pokud jsi dívka, přesvědč jednoho muže z okolí, aby na kontrolu zašel.',
          challenger: ''
        },
        {
          id: 46,
          type: 'vyziva',
          text: 'Vynech rafinované cukry v podobě čokoládových tyčinek, dortů, zákusků, atp.',
          challenger: ''
        },
        {
          id: 47,
          type: 'pohyb',
          text: 'Výzva Pepého Kalenského',
          challenger: 'pepe-kalensky'
        },
        {
          id: 48,
          type: 'vzdelani',
          text: 'Na webu Sifty si pozorně přečti infografiku na téma HIV bit.ly/Sifty48',
          challenger: ''
        },
        {
          id: 49,
          type: 'prevence',
          text: 'Utři v celé domácnosti prach a ulev plicím. Zkontroluj také, zda se ti doma neusadily plísně',
          challenger: ''
        },
        {
          id: 50,
          type: 'pohyb',
          text: 'V tomto týdnu naskákej celkem alespoň 5 minut přes švihadlo',
          challenger: ''
        },
        {
          id: 51,
          type: 'vyziva',
          text: 'Uvař si každý den alespoň jedno jídlo doma',
          challenger: ''
        },
        {
          id: 52,
          type: 'psychohygiena',
          text: 'Máme sice svátky klidu, ale často jsou také zdrojem stresu a napětí. Najdi si každý den alespoň 5 minut pro sebe, zavři oči a zhluboka dýchej',
          challenger: ''
        }
      ]
    },
  mutations: {
    handleModal (state, item) {
      state.modals[item] = !state.modals[item];
    }
  }
});



// WEBPACK FOOTER //
// ./src/store.js